import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { AngularPlugin } from '@microsoft/applicationinsights-angularplugin-js';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TelemetryService {
  private appInsights!: ApplicationInsights;

  constructor(private router: Router) {
    if (
      environment.appInsightsConnectionString &&
      environment.appInsightsConnectionString !== 'REPLACE_WITH_APP_INSIGHTS_CONNECTION_STRING'
    ) {
      const angularPlugin = new AngularPlugin();

      this.appInsights = new ApplicationInsights({
        config: {
          connectionString: environment.appInsightsConnectionString,
          extensions: [angularPlugin],
          extensionConfig: {
            [angularPlugin.identifier]: {
              router: this.router,
              // We leave errorServices empty because we have our own GlobalErrorHandler
              errorServices: [],
            },
          },
          enableAutoRouteTracking: true,
          enableCorsCorrelation: true,
          enableRequestHeaderTracking: true,
          enableResponseHeaderTracking: true,
        },
      });

      this.appInsights.loadAppInsights();

      // Tag all telemetry with the platform name (e.g., 'web-admin')
      this.appInsights.addTelemetryInitializer((envelope) => {
        envelope.tags = envelope.tags || [];
        envelope.tags['ai.cloud.role'] = environment.platform || 'web-admin';
      });
    }
  }

  public logException(error: Error, severityLevel?: number) {
    if (this.appInsights) {
      this.appInsights.trackException({ exception: error, severityLevel });
    }
  }

  public logEvent(name: string, properties?: { [key: string]: any }) {
    if (this.appInsights) {
      this.appInsights.trackEvent({ name }, properties);
    }
  }

  // Call this when the user logs in to attach their ID to all future errors
  public setUserId(userId: string) {
    if (this.appInsights) {
      this.appInsights.setAuthenticatedUserContext(userId);
    }
  }

  // Call this when the user logs out
  public clearUserId() {
    if (this.appInsights) {
      this.appInsights.clearAuthenticatedUserContext();
    }
  }
}
